const COLLECTION_ID = 'Z2lkOi8vc2hvcGlmeS9Db2xsZWN0aW9uLzcwMDQ1NDg2MzIxNw==';

export const suppliesStoreConstants = {
  SHOPIFY_GRAPHQL_URL: 'https://shipstation-supplies.myshopify.com/api/2026-04/graphql.json',
  FETCH_PRODUCTS_QUERY: `
  query GetSuppliesProducts {
    collection(id: "${COLLECTION_ID}") {
      id
      title
      products(first: 30) {
        edges {
          node {
            id
            title
            images(first: 2) {
              edges {
                node {
                  url
                  altText
                }
              }
            }
            featuredImage {
              url
              altText
            }
            category {
              id
              name
            }
            variants(first: 1) {
              edges {
                node {
                  id
                  title
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                  availableForSale
                }
              }
            }
          }
        }
      }
    }
  }
`,
  CREATE_CHECKOUT_MUTATION: `
    mutation CreateCart($input: CartInput!) {
      cartCreate(input: $input) {
        cart {
          id
          checkoutUrl
        }
        userErrors {
          code
          field
          message
        }
      }
    }
  `,
};
